import React from "react";
import "./Body.css";
import heroBanner from "../assets/relyonn-home-page-banner-min.png";

function Body() {
  return (
    <section
      className="hero"
      style={{
        backgroundImage: `url(${heroBanner})`,
      }}
    >
      <div className="hero-overlay">
        <div className="hero-content">
          <span className="hero-tag">WELCOME TO RELYONNE UK LIMITED</span>

          <h1>
            Your Complete Paper &amp; Board
            <br />
            <span className="highlight">Solutions Partner</span>
          </h1>

          <p>
            RelyOnne UK Limited has been simplifying paper and
            board sourcing for businesses by providing reliable products,
            dependable logistics, and long-term partnerships across the Globe
            and international markets.
          </p>

          <a href="/contact" className="hero-btn">
          Get in Touch →
          </a>
        </div>
      </div>
    </section>
  );
}

export default Body;